const iconPaths = {
  phone: <path d="M7.1 3.5 9 7.8 6.8 9.3c1.2 2.6 3.3 4.7 5.9 5.9l1.5-2.2 4.3 1.9-.5 3.4c-.1.8-.8 1.4-1.6 1.4C9.7 19.7 4.3 14.3 4.3 7.6c0-.8.6-1.5 1.4-1.6l1.4-2.5Z" />,
  mail: <><path d="M3.5 6.5h17v12h-17z" /><path d="m4.2 7.2 7.8 6 7.8-6" /></>,
  arrow: <><path d="M5 12h14" /><path d="m14 7 5 5-5 5" /></>,
  heart: <path d="M12 20S4.5 15.8 4.5 9.7A4.2 4.2 0 0 1 12 7a4.2 4.2 0 0 1 7.5 2.7C19.5 15.8 12 20 12 20Z" />,
  home: <><path d="m3 11 9-7 9 7" /><path d="M5.5 9.5V20h13V9.5M9 20v-6h6v6" /></>,
  people: <><circle cx="9" cy="8" r="3" /><circle cx="17" cy="9" r="2" /><path d="M3.5 20c.3-4 2.2-6 5.5-6s5.2 2 5.5 6M14 15c3.7-.5 5.9 1.2 6.5 5" /></>,
  meal: <><path d="M7 3v8M4 3v5a3 3 0 0 0 6 0V3M7 11v10M17 3v18M14 3v7h3" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>,
  medical: <><path d="M8 4H5a2 2 0 0 0-2 2v12h18V6a2 2 0 0 0-2-2h-3" /><path d="M9 4V2h6v2M12 8v6M9 11h6" /></>,
  access: <><circle cx="12" cy="4" r="2" /><path d="m10 8 4 1 2 4h3M12 9l-2 5-4 1M10 14a4 4 0 1 0 5.8 3.6" /></>,
  lift: <><path d="M5 3h14v18H5zM9 7l3-3 3 3M9 17l3 3 3-3" /></>,
  garden: <><path d="M12 21V9M12 13c-5 0-7-3-7-7 5 0 7 3 7 7ZM12 16c5 0 7-3 7-7-5 0-7 3-7 7Z" /></>,
  room: <><path d="M4 21V4h16v17M8 21v-8h8v8M8 8h.01" /></>,
  tv: <><rect x="3" y="6" width="18" height="13" rx="2" /><path d="m9 2 3 4 3-4M9 22h6" /></>,
  chair: <><path d="M7 13V5a3 3 0 0 1 6 0v8M5 13h11a3 3 0 0 1 3 3v2H5v-5ZM7 18v3M17 18v3" /></>,
  paw: <><circle cx="12" cy="15" r="4" /><circle cx="6" cy="10" r="2" /><circle cx="10" cy="6" r="2" /><circle cx="16" cy="7" r="2" /><circle cx="19" cy="12" r="2" /></>,
  location: <><path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  external: <><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v5H5V6h5" /></>,
  menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
  close: <><path d="m6 6 12 12M18 6 6 18" /></>,
  quote: <path d="M6 17h4l2-5V6H5v6h4l-3 5Zm10 0h4l2-5V6h-7v6h4l-3 5Z" />,
};

const Icon = ({ name, size = 24, className = "" }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    >
      {iconPaths[name]}
    </g>
  </svg>
);

export default Icon;
